import { X } from "lucide-react";

const DIET_PRICE = 9.99;

const DietPlanUpsellModal = ({ planName, planPrice, onAdd, onDecline, onClose }) => {
  const total = (planPrice + DIET_PRICE).toFixed(2);

  return (
    <div className="fixed inset-0 bg-black/90 flex items-end sm:items-center justify-center z-50 p-3">
      <div className="bg-[#0A0A0A] border border-[#00E5FF]/40 w-full max-w-md relative overflow-hidden max-h-[88svh] overflow-y-auto">
        <div className="h-1 w-full" style={{ background: "#00E5FF" }} />
        <button onClick={onClose} className="absolute top-3 right-3 text-white/40 hover:text-white z-10">
          <X className="w-5 h-5" />
        </button>

        <div className="p-5 space-y-4">
          <div>
            <p className="text-[#00E5FF] text-xs font-bold uppercase tracking-widest mb-1">Add-On Offer</p>
            <h2 className="text-xl font-black uppercase text-white leading-tight">
              Add Custom Diet Plan
            </h2>
            <p className="text-white text-sm mt-1">
              Personalized meals, macros, and grocery list — built around your boxing schedule.
            </p>
          </div>

          <div className="border border-white/10 p-4 space-y-2">
            <div className="flex justify-between text-sm">
              <span className="text-white">{planName} Membership</span>
              <span className="text-white font-mono">${planPrice.toFixed(2)}/mo</span>
            </div>
            <div className="flex justify-between text-sm">
              <span className="text-white">Custom Diet Plan</span>
              <span className="text-white font-mono">$9.99/mo</span>
            </div>
            <div className="border-t border-white/10 pt-2 flex justify-between font-bold">
              <span className="text-white">Total</span>
              <span className="text-[#00E5FF] font-mono">${total}/mo</span>
            </div>
          </div>

          <p className="text-white text-xs">
            Add the Custom Diet Plan for $9.99/month. Total ${total}/month.
          </p>

          <div className="space-y-3">
            <button
              onClick={onAdd}
              className="w-full py-3 font-black uppercase tracking-widest text-black text-sm"
              style={{ background: "#00E5FF" }}
              data-testid="diet-upsell-add-btn"
            >
              Add Custom Diet Plan  >
            </button>
            <button
              onClick={onDecline}
              className="w-full text-white/60 hover:text-white text-sm py-1 transition-colors"
              data-testid="diet-upsell-decline-btn"
            >
              No thanks, continue without it
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DietPlanUpsellModal;
